import React, { useState, useEffect } from 'react';
import { Form, Spinner, Alert } from 'react-bootstrap';
import { listBasicAgents } from '../../../services/AgentsServices';

const AgentSelector = ({ 
  value, 
  onChange, 
  error = null, 
  disabled = false,
  required = true 
}) => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    loadAgents();
    console.log(value);
  }, []);

  const loadAgents = async () => {
    try {
      setLoading(true);
      setLoadError(null);
      
      let params = {
        "limit": 50
      }
      const response = await listBasicAgents(params);
      if (response.success) {
        setAgents(response.agents || []);
      } else {
        throw new Error(response.error || 'Erro ao carregar agentes');
      }
    } catch (error) {
      console.error('Erro ao carregar agentes:', error);
      setLoadError('Erro ao carregar lista de agentes. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Form.Group className="mb-3">
        <Form.Label>
          Agente *
        </Form.Label>
        <div className="d-flex align-items-center p-3 border rounded bg-light">
          <Spinner animation="border" size="sm" className="me-2" />
          <span className="text-muted">Carregando agentes...</span>
        </div>
      </Form.Group>
    );
  }

  if (loadError) {
    return (
      <Form.Group className="mb-3">
        <Form.Label>
          Agente *
        </Form.Label>
        <Alert variant="danger" className="mb-0">
          <div className="d-flex justify-content-between align-items-center">
            <span>{loadError}</span>
            <button 
              type="button" 
              className="btn btn-sm btn-outline-danger"
              onClick={loadAgents}
            >
              <i className="las la-redo-alt" /> Tentar Novamente
            </button>
          </div>
        </Alert>
      </Form.Group>
    );
  }

  return (
    <Form.Group className="mb-3">
      <Form.Label>
        Agente {required && '*'}
      </Form.Label>
      
      <Form.Select
        value={value?.id || value || ''}
        onChange={(e) => {
          const selectedId = e.target.value ? parseInt(e.target.value) : null;
          const selectedAgent = selectedId ? agents.find(agent => agent.id === selectedId) : null;
          onChange(selectedAgent);
        }}
        disabled={disabled}
        isInvalid={!!error}
        required={required}
      >
        <option value="">Selecione um agente...</option>
        {agents.map((agent) => (
          <option key={agent.id} value={agent.id}>
            {agent.agent_name} {agent.agent_job && `- ${agent.agent_job}`}
          </option>
        ))}
      </Form.Select>
      
      {error && (
        <Form.Control.Feedback type="invalid">
          {error}
        </Form.Control.Feedback>
      )}
      
      {agents.length === 0 && (
        <Form.Text className="text-muted">
          <i className="las la-info-circle me-1" />
          Nenhum agente disponível para publicação. Certifique-se de ter agentes criados e ativos.
        </Form.Text>
      )}
      
      {(value?.id || value) && agents.length > 0 && (
        <Form.Text className="text-muted">
          <i className="las la-lightbulb me-1" />
          Este agente será publicado no marketplace com as informações fornecidas.
        </Form.Text>
      )}
    </Form.Group>
  );
};

export default AgentSelector;